<template>
	<div>
		<!-- Company Logo & Name -->
		<div 
			v-if="offer.company && !hide.includes('company')"
			class="flex-vertical-center justify-content-center flex-wrap flex-column"
			:class="{'hide-on-print': hideonprint}"
		>
			<div class="logo-container">
				<img
					v-if="$siteconf.logo"
					:src="offer.company_logo"
					class="company-logo"
				>
			</div>
			<h6>{{ offer.company }}</h6>
		</div>
  
		<!-- Job Title -->
		<h6 
			v-if="offer.job_title && !hide.includes('job_title')"
			class="ps-3"
		>
			{{ offer.job_title }}
		</h6>
  
		<!-- Offer Details (Dynamic List) -->
		<div 
			v-for="item in filteredOfferDetails" 
			:key="item.key"
			class="body1 flex-vertical-center"
		>
			<span class="material-icons-outlined fs-5 me-2">
				{{ item.icon }}
			</span>
			{{ item.text }}
		</div>
	</div>
</template>

<script>
import { EducationLevel, Contract } from "@/utils/constants";

export default {
    props: {
        offer: {
            type: Object,
            required: true
        },
        hideonprint: {
            type: Boolean,
            default: false
        },
        hide: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            EducationLevel,
            Contract,
            
        }
    },
    computed: {
        offerDetails() {
            return [
                {
                    key: 'date',
                    icon: 'schedule',
                    text: `${this.$t('Publiée')}: ${new Date(this.offer.date).toLocaleDateString("fr")}`
                },
                {
                    key: 'contract',
                    icon: 'description',
                    text: this.getContract
                },
                {
                    key: 'location',
                    icon: 'place',
                    text: this.offer.location
                },
                {
                    key: 'edu_lvl',
                    icon: 'school',
                    text: this.$t('education.' + this.offer.edu_lvl)
                },
                {
                    key: 'exp_lvl',
                    icon: 'work',
                    text: `${this.offer.exp_lvl} ${this.$t('ans')}`
                },
                {
                    key: 'salary',
                    icon: 'payments',
                    text: this.salary
                }
            ];
        },
        filteredOfferDetails() {
            return this.offerDetails.filter(item =>
                this.offer[item.key] && !this.hide.includes(item.key)
            );
        },
        education() {
            return EducationLevel[this.offer.edu_lvl];
        },
        getContract() {
            const contracts = this.offer?.contract ? this.offer.contract.split(', ') : [];
            if (contracts.length) {
                return contracts.map(c => this.$t('contract.' + c)).join(', ')
            }
            return '';
        },
        salary() {
            let salary = this.offer.salary
            let salaryText = ""
            if (salary) {
                if (!salary.min && !salary.max) return ""
                if (salary.min && salary.max && salary.min == salary.max) salaryText += salary.min
                else if (salary.min && salary.max) salaryText += salary.min + "-" + salary.max
                else if (salary.min) salaryText += salary.min
                else if (salary.max) salaryText += salary.max
                salaryText += salary.currency === 'EUR' || !salary.currency ? '€' : '$';
                if (salary.period) salaryText += "/" + this.$t(this.offer.salary.period)
                return salaryText
            }
            else return salaryText
        }
    },
}
</script>
<style scoped>
    .logo-container {
    max-width: 200px;
    max-height: 100px;
    }

    .company-logo {
    max-height: 100px;
    max-width: 100%;
    padding-bottom: 1rem;
    }

    @media print {
    .hide-on-print {
        display: none !important;
    }
    }
</style>